import { useEffect } from "react";

export const SITE_URL = "https://www.vemoyefoundation.org";
export const DEFAULT_DESC =
  "Vemoye Foundation strengthens the Nigerian organisations equipping young people with the skills, mindset and opportunity to build Nigeria's future.";

export const ROUTE_META = {
  "/":                  { title: "Vemoye Foundation — Building Nigeria's Future Workforce", desc: DEFAULT_DESC },
  "/about":             { title: "About | Vemoye Foundation", desc: "Vemoye Foundation exists to build the education system Nigeria's next generation deserves — one designed for the century they'll actually inherit." },
  "/what-we-do":        { title: "What We Do | Vemoye Foundation", desc: "Consultancy, skills-based diaspora support, and physical resource provision for the organisations equipping Nigerian young people." },
  "/organisations":     { title: "Organisations We Support | Vemoye Foundation", desc: "The Nigerian STEM, entrepreneurship and leadership organisations Vemoye Foundation strengthens." },
  "/diaspora":          { title: "Diaspora Network | Vemoye Foundation", desc: "A curated network of Nigerian diaspora professionals contributing skills, expertise and time to Nigeria's future." },
  "/partner":           { title: "Partner With Us | Vemoye Foundation", desc: "Fund, support or collaborate with Vemoye Foundation to strengthen Nigerian education organisations." },
  "/webinars":          { title: "Webinars & Events | Vemoye Foundation", desc: "Curated webinars and events from the Vemoye Diaspora Network on building Nigeria's future workforce." },
  "/join":              { title: "Apply to the Diaspora Network | Vemoye Foundation", desc: "Apply to join the Vemoye Diaspora Network — free membership, by application." },
  "/join/waitinglist":  { title: "You're on the list | Vemoye Diaspora Network", desc: "Thank you for applying to the Vemoye Diaspora Network. Your application has been received and added to the founding waiting list." },
  "/donate":            { title: "Donate | Vemoye Foundation", desc: "Support Vemoye Foundation and help strengthen the organisations building Nigeria's future workforce." },
  "/apply-for-support": { title: "Apply for Support | Vemoye Foundation", desc: "Nigerian organisations equipping young people can apply for Vemoye Foundation's consultancy, diaspora expertise and resources." },
  "/privacy":           { title: "Privacy Policy | Vemoye Foundation", desc: "How Vemoye Foundation handles your personal information." },
  "/terms":             { title: "Terms & Conditions | Vemoye Foundation", desc: "The terms that govern your use of the Vemoye Foundation website and network." },
};

const setMeta = (selector, attr, value, createFn) => {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = createFn();
    document.head.appendChild(tag);
  }
  tag.setAttribute(attr, value);
};

export const usePageSEO = (pathname) => {
  useEffect(() => {
    const meta = ROUTE_META[pathname] || { title: "Vemoye Foundation", desc: DEFAULT_DESC };
    const url = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;
    document.title = meta.title;

    setMeta('meta[name="description"]', "content", meta.desc, () => {
      const t = document.createElement("meta");
      t.setAttribute("name", "description");
      return t;
    });
    setMeta('link[rel="canonical"]', "href", url, () => {
      const t = document.createElement("link");
      t.setAttribute("rel", "canonical");
      return t;
    });

    const ogPairs = [["og:title", meta.title], ["og:description", meta.desc], ["og:url", url]];
    ogPairs.forEach(([prop, val]) => {
      setMeta(`meta[property="${prop}"]`, "content", val, () => {
        const t = document.createElement("meta");
        t.setAttribute("property", prop);
        return t;
      });
    });

    const twPairs = [["twitter:title", meta.title], ["twitter:description", meta.desc]];
    twPairs.forEach(([name, val]) => {
      setMeta(`meta[name="${name}"]`, "content", val, () => {
        const t = document.createElement("meta");
        t.setAttribute("name", name);
        return t;
      });
    });
  }, [pathname]);
};
